/**
 * Actions for the Global Context.
 */
export const enum GLOBAL_CONTEXT_ACTION_TYPE {
  CLEAR_ALL_CONTEXTS = "CLEAR_ALL_CONTEXTS",
  CLEAR_UNUSED_CONTEXTS = "CLEAR_UNUSED_CONTEXTS",

  SET_LOADING = "SET_LOADING",

  SET_IS_UPGRADE = "SET_IS_UPGRADE",
  SET_ACCOUNT_NUMBER = "SET_IS_ACCOUNT_NUMBER",

  SET_COUNTRY_CODE = "SET_COUNTRY_CODE",
  SET_EMAIL = "SET_EMAIL",
  SET_PHONE_NUMBER = "SET_PHONE_NUMBER",
  SET_FIRST_NAME = "SET_FIRST_NAME",
  SET_IS_NEW_USER = "SET_IS_NEW_USER",

  SET_OPEN_NOTIFICATION = "SET_OPEN_NOTIFICATION",
  CLEAR_NOTIFICATION_CONTEXT = "CLEAR_NOTIFICATION_CONTEXT",

  SET_ACTIVE_STEP = "SET_ACTIVE_STEP",
  SET_MAX_STEP = "SET_MAX_STEP",

  SET_PAYMENTS_CONTEXT = "SET_PAYMENTS_CONTEXT",
  CLEAR_PAYMENTS_CONTEXT = "CLEAR_PAYMENTS_CONTEXT",

  SET_SERVICE_FAILURE = "SET_SERVICE_FAILURE",

  SET_SEND_MONEY_CONTEXT = "SET_SEND_MONEY_CONTEXT",
  CLEAR_SEND_MONEY_CONTEXT = "CLEAR_SEND_MONEY_CONTEXT",

  SET_TRANSACTIONS_CONTEXT = "SET_TRANSACTIONS_CONTEXT",
  CLEAR_TRANSACTIONS_CONTEXT = "CLEAR_TRANSACTIONS_CONTEXT",

  SET_SELFIES_CONTEXT = "SET_SELFIES_CONTEXT",

  SET_POS_CONTEXT = "SET_POS_CONTEXT",
  CLEAR_POS_CONTEXT = "CLEAR_POS_CONTEXT",

  SET_REGISTRATION_CONTEXT = "SET_REGISTRATION_CONTEXT",

  SET_SIGNUP_CONTEXT = "SET_SIGNUP_CONTEXT",

  SET_ONBOARDING_CONTEXT = "SET_SIGNUP_CONTEXT",

  SET_USER_DETAILS_CONTEXT = "SET_USER_DETAILS_CONTEXT",

  SET_PAYMENT_LINK_CONTEXT = "SET_PAYMENT_LINK_CONTEXT",
  CLEAR_PAYMENT_LINK_CONTEXT = "CLEAR_PAYMENT_LINK_CONTEXT",

  SET_LOANS_CONTEXT = "SET_LOANS_CONTEXT",
  CLEAR_LOANS_CONTEXT = "CLEAR_LOANS_CONTEXT",

  SET_SETTINGS_CONTEXT = "SET_SETTINGS_CONTEXT",
  CLEAR_SETTINGS_CONTEXT = "CLEAR_SETTINGS_CONTEXT",

  SET_PERSONAL_DETAILS_CONTEXT = "SET_PERSONAL_DETAILS_CONTEXT",
  CLEAR_PERSONAL_DETAILS_CONTEXT = "CLEAR_PERSONAL_DETAILS_CONTEXT",

  SET_UPGRADE_CONTEXT = "SET_UPGRADE_CONTEXT",
  CLEAR_UPGRADE_CONTEXT = "CLEAR_UPGRADE_CONTEXT",

  SET_OUTLET_CONTEXT = "SET_OUTLET_CONTEXT",
  SET_OUTLETS = "SET_OUTLETS",
  SET_OUTLET_SELECTION = "SET_OUTLET_SELECTION",
  CLEAR_OUTLET_CONTEXT = "CLEAR_OUTLET_CONTEXT",
}
